import { Resolver } from "react-hook-form";
import { compileNameOfProperty } from "../../utils/utils";
import { isValidPhoneNumber } from "../../validation/validation";
import { IUserSignup } from "./container";

export const LoginResolver: Resolver<IUserSignup> = async (values: IUserSignup) => {
    let errors = {};
    Object.entries(values).forEach(([name, value]) => {
        if (name === compileNameOfProperty<IUserSignup>("phoneNumber")) {
            if (!isValidPhoneNumber(value)) {
                errors = {
                    ...errors,
                    [name]: {
                        type: "required",
                        message: "VALIDATION.PHONE",
                    },
                };
            }
        } else {
            if (!value) {
                errors = {
                    ...errors,
                    [name]: {
                        type: "required",
                        message: "VALIDATION.REQUIRE",
                    },
                };
            }
        }
    });
    return { values, errors };
};
